import * as React from 'react';
import { InlineText2, ArticleHeading2, Image } from '@cian/ui-kit';

import * as styles from './styles.css';
import { ISeller } from '../../../../types/newbuilding/seller';

export function AgentsItem({ name, avatarUrl }: ISeller) {
  return (
    <div className={styles['container']}>
      <div className={styles['present-info']}>
        <div className={styles['title']}>
          <InlineText2 color="gray60_100">Агентство недвижимости</InlineText2>
          <ArticleHeading2 as="h2">{name}</ArticleHeading2>
        </div>
        {avatarUrl && <Image src={avatarUrl} width={48} height={48} borderRadius="4px" objectFit="contain" />}
      </div>
    </div>
  );
}
